<template>
  <div class="d d_xm">
    <headers :goBack="goBack" :isForm="1" />
    <van-form
      @submit="onClickButtonSubmit"
      validate-trigger="onSubmit"
      @failed="handleFailed"
    >
      <div class="kuang">
        <diy-picker
          title="学校类型"
          :value="schoolTypeTxt"
          :list="schoolTypes"
          :handlerSelect="selectSchoolTypes"
          :isClick="true"
          :isRequired="schoolTypeFlag"
        />

        <van-field
          v-if="schoolType > 0"
          name="radio"
          label="学校是否建队"
          class="radioFlex"
          required
          :rules="[{ required: true, message: '请填写选择学校是否建队' }]"
        >
          <template #input>
            <van-radio-group
              v-model="schoolBuildingTeam"
              direction="horizontal"
              v-for="item in buildingTeamList"
              v-bind:key="item.key"
              @change="radioChange($event, 'levelSGWDirector', clearSchoolBuild)"
            >
              <van-radio :name="item.key" checked-color="#ff6865">{{
                item.value
              }}</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field
          name="radio"
          label="是否为大队辅导员"
          v-if="schoolBuildingTeam == 1"
          class="radioFlex"
          required
          :rules="[{ required: true, message: '请填写选择是否为大队辅导员' }]"
        >
          <template #input>
            <van-radio-group
              v-model="isBrigadeCounselor"
              direction="horizontal"
              v-for="item in yORn"
              v-bind:key="item.key"
              @change="radioChange($event, 'isBrigadeCounselor', clearSchoolCounselor)"
            >
              <van-radio :name="item.key" checked-color="#ff6865">{{
                item.value
              }}</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <template v-if="isBrigadeCounselor == 1">
          <van-field
            required
            v-model="name"
            clearable
            label="姓名"
            placeholder="请输入姓名"
            :rules="[{ required: true, message: '请填写姓名' }]"
          />
          <van-field
            required
            name="radio"
            label="性别"
            class="radioFlex"
            :rules="[{ required: true, message: '请选择性别' }]"
          >
            <template #input>
              <van-radio-group
                v-model="sex"
                direction="horizontal"
                v-for="item in sexs"
                v-bind:key="item.key"
              >
                <van-radio :name="item.key" checked-color="#ff6865">{{
                  item.value
                }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <datetime-picker
            :value="birthday"
            title="出生日期"
            type="year-month"
            :callback="(val) => handlerSelect('birthday', val)"
            :isRequired="birthdayFlag"
          />

          <van-field
            required
            name="radio"
            label="学历"
            :rules="[{ required: true, message: '请选择学历' }]"
          >
            <template #input>
              <van-radio-group
                v-model="edu"
                v-for="item in eduList"
                v-bind:key="item.key"
              >
                <van-radio :name="item.key" checked-color="#ff6865">{{
                  item.value
                }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>

          <van-field
            required
            name="radio"
            label="政治面貌"
            :rules="[{ required: true, message: '请选择政治面貌' }]"
          >
            <template #input>
              <van-radio-group
                v-model="zzmm"
                v-for="item in zzmmList"
                v-bind:key="item.key"
              >
                <van-radio :name="item.key" checked-color="#ff6865">{{
                  item.value
                }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>

          <van-field
            required
            v-model="tel"
            clearable
            label="手机号"
            placeholder="请输入手机号"
            maxlength="11"
            :rules="[
              { required: true, message: '请输入手机号' },
              {
                pattern: /^1[3456789]\d{9}$/,
                message: '手机号格式错误',
              },
            ]"
          />
          <van-field
            required
            name="radio"
            label="校内职务"
            :rules="[{ required: true, message: '请选择校内职务' }]"
          >
            <template #input>
              <van-radio-group
                v-model="job"
                v-for="item in jobList"
                v-bind:key="item.key"
                direction="vertical"
              >
                <van-radio :name="item.key" checked-color="#ff6865">{{
                  item.value
                }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>

          <datetime-picker
            :value="counselorTime"
            title="担任大队辅导员时间"
            type="year-month"
            :callback="(val) => handlerSelect('counselorTime', val)"
            :isRequired="counselorTimeFlag"
          />

          <van-field
            required
            name="radio"
            label="职称"
            :rules="[{ required: true, message: '请选择职称' }]"
          >
            <template #input>
              <van-radio-group
                v-model="title"
                v-for="item in titleList"
                v-bind:key="item.key"
                direction="vertical"
              >
                <van-radio :name="item.key" checked-color="#ff6865">{{
                  item.value
                }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            van-field
            required
            name="radio"
            label="兼教课程"
            :rules="[{ required: true, message: '请选择兼教课程' }]"
          >
            <template #input>
              <van-radio-group
                v-model="concurrentCourses"
                v-for="item in concurrentCoursesList"
                v-bind:key="item.key"
                direction="vertical"
                @change="radioChange($event, 'concurrentCourses', clearConcurrentCourses)"
              >
                <van-radio :name="item.key" checked-color="#ff6865">{{
                  item.value
                }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            v-if="concurrentCourses > 1"
            required
            v-model="classHour"
            clearable
            type="digit"
            label="每周课时"
            placeholder="请输入每周课时"
            :rules="[
              { required: true, message: '请输入每周课时' },
              { validator, message: '请输入每周课时' },
            ]"
          />
        </template>

        <template v-if="schoolBuildingTeam == 1">

          <van-field
            required
            name="radio"
            label="所在学校的日常少先队活动时间如何安排"
            :rules="[{ required: true, message: '请选择所在学校的日常少先队活动时间如何安排' }]"
          >
            <template #input>
              <van-radio-group
                v-model="eventSchedule"
                v-for="item in eventScheduleList"
                v-bind:key="item.key"
                direction="vertical"
                 @change="radioChange($event, 'eventSchedule', clearEventSchedule)"
              >
                <van-radio :name="item.key" checked-color="#ff6865">{{
                  item.value
                }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            v-if="eventSchedule == 5"
            required
            v-model="eventScheduleOther"
            clearable
            type="digit"
            label="平均每周课时"
            placeholder="请输入平均每周课时"
            :rules="[
              { required: true, message: '请输入平均每周课时' },
              { validator: validatorNum, message: '平均每周课时的范围是0~10000' },
            ]"
          />


          <van-field
            required
            v-model="squadronNum"
            clearable
            type="digit"
            label="中队数量"
            placeholder="请输入中队数量"
            :rules="[
              { required: true, message: '请输入中队数量' },
              { validator: validatorNum, message: '中队数量的范围是0~10000' },
            ]"
          />
          <van-field
            required
            v-model="squadronCounselorsNum"
            clearable
            type="digit"
            label="中队辅导员人数"
            placeholder="请输入中队辅导员人数"
            :rules="[
              { required: true, message: '请输入中队辅导员人数' },
              { validator, message: '请输入中队辅导员人数' },
            ]"
          />
          <van-cell title="中队辅导员政治面貌：" :border="false"/>
          <van-field
            required
            v-model="squadronCounselorsPartyNum"
            clearable
            type="digit"
            label="党员人数"
            placeholder="请输入党员人数"
            :rules="[
              { validator: handleCheckSquadronPeople, message: '党员、团员、群众、其他人数的总数须等于中队辅导员人数' },
            ]"
          />
          <van-field
            required
            v-model="squadronCounselorsLeagueNum"
            clearable
            type="digit"
            label="团员人数"
            placeholder="请输入团员人数"
            :rules="[
              { validator: handleCheckSquadronPeople, message: '党员、团员、群众、其他人数的总数须等于中队辅导员人数' },
            ]"
          />
          <van-field
            required
            v-model="squadronCounselorsPeopleNum"
            clearable
            type="digit"
            label="群众人数"
            placeholder="请输入群众人数"
            :rules="[
              { validator: handleCheckSquadronPeople, message: '党员、团员、群众、其他人数的总数须等于中队辅导员人数' },
            ]"
          />
           <van-field
            required
            v-model="squadronCounselorsOtherNum"
            clearable
            type="digit"
            label="其他人数"
            placeholder="请输入其他人数"
            :rules="[
              { validator: handleCheckSquadronPeople, message: '党员、团员、群众、其他人数的总数须等于中队辅导员人数' },
            ]"
          />

          <!-- <van-field
            name="radio"
            label="副大队辅导员人数"
            :rules="[{ required: true, message: '请选择副大队辅导员人数' }]"
          >
            <template #input>
              <van-radio-group
                v-model="viceCounselor"
                v-for="item in viceCounselorList"
                v-bind:key="item.key"
                direction="vertical"
              >
                <van-radio :name="item.key" checked-color="#ff6865">{{
                  item.value
                }}</van-radio>
              </van-radio-group>
            </template>
          </van-field> -->

          <van-field
            required
            v-model="viceCounselorNum"
            clearable
            type="digit"
            label="副大队辅导员（执行大队辅导员）人数"
            placeholder="请输入副大队辅导员（执行大队辅导员）人数"
            :rules="[
              { required: true, message: '请输入副大队辅导员（执行大队辅导员）人数' },
              { validator: validatorMax, message: '请输入副大队辅导员（执行大队辅导员）人数' },
            ]"
          />

          <van-field
            required
            v-model="youngNum"
            clearable
            type="digit"
            label="少先队员人数"
            placeholder="请输入少先队员人数"
            :rules="[
              { required: true, message: '请输入少先队员人数' },
              { validator, message: '请输入少先队员人数' },
            ]"
          />

          <van-field
            v-if="schoolType > 2"
            v-model="recommender"
            clearable
            type="digit"
            label="今年推荐作为团的发展对象的少先队员人数"
            placeholder="请输入今年推荐作为团的发展对象的少先队员人数"
          />

          <van-field
            v-model="brigadeOutsideCounselorsNum"
            clearable
            type="digit"
            label="大队聘请的校外辅导员总人数"
            placeholder="请输入大队聘请的校外辅导员总人数"
          />
          <van-field
            v-model="squadronOutsideCounselorsNum"
            clearable
            type="digit"
            label="中队聘请的校外辅导员总人数"
            placeholder="请输入中队聘请的校外辅导员总人数"
          />

          <!-- （仅小学填写） -->
          <div v-if="(schoolType < 9 && schoolType >= 5) || schoolType <= 2">
            <van-field
              van-field
              required
              name="radio"
              label="目前学校学生分几批次入队"
              :rules="[{ required: true, message: '请选择目前学校学生分几批次入队' }]"
              v-if="(schoolType < 9 && schoolType >= 5) || schoolType <= 2"
            >
              <template #input>
                <van-radio-group
                  v-model="batchTeam"
                  v-for="item in batchTeamList"
                  v-bind:key="item.key"
                  direction="vertical"
                >
                  <van-radio :name="item.key" checked-color="#ff6865">{{
                    item.value
                  }}</van-radio>
                </van-radio-group>
              </template>
            </van-field>

            <van-field
              v-if="(schoolType < 9 && schoolType >= 5) || schoolType <= 2"
              required
              name="radio"
              label="目前学生入队时首次佩戴的红领巾是否由学校统一配发"
              class="radioFlex"
              :rules="[
                {
                  required: true,
                  message: '请选择目前学生入队时首次佩戴的红领巾是否由学校统一配发',
                },
              ]"
            >
              <template #input>
                <van-radio-group
                  v-model="redScarf"
                  direction="horizontal"
                  v-for="item in yORn"
                  v-bind:key="item.key"
                >
                  <van-radio :name="item.key" checked-color="#ff6865">{{
                    item.value
                  }}</van-radio>
                </van-radio-group>
              </template>
            </van-field>

            <van-field
              v-if="(schoolType < 9 && schoolType >= 5) || schoolType <= 2"
              required
              name="radio"
              label="目前学生入队时首次佩戴的队徽徽章是否由学校统一配发"
              class="radioFlex"
              :rules="[
                {
                  required: true,
                  message: '请选择目前学生入队时首次佩戴的队徽徽章是否由学校统一配发',
                },
              ]"
            >
              <template #input>
                <van-radio-group
                  v-model="badge"
                  direction="horizontal"
                  v-for="item in yORn"
                  v-bind:key="item.key"
                >
                  <van-radio :name="item.key" checked-color="#ff6865">{{
                    item.value
                  }}</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>

          <van-field
            required
            name="radio"
            label="目前学校是否开展“红领巾奖章”基础章争章活动"
            class="radioFlex"
            :rules="[
              {
                required: true,
                message: '请选择目前学校是否开展“红领巾奖章”基础章争章活动',
              },
            ]"
          >
            <template #input>
              <van-radio-group
                v-model="redScarfMedal"
                direction="horizontal"
                v-for="item in yORn"
                v-bind:key="item.key"
                @change="radioChange($event, 'redScarfMedal', clearRedScarfMedal)"
              >
                <van-radio :name="item.key" checked-color="#ff6865">{{
                  item.value
                }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>

          <div v-if="redScarfMedal == 1">
            <van-field
              required
              name="radio"
              label="是否颁发了一星章"
              class="radioFlex"
              :rules="[{ required: true, message: '请选择是否颁发了一星章' }]"
            >
              <template #input>
                <van-radio-group
                  v-model="oneStar"
                  direction="horizontal"
                  v-for="item in yORn"
                  v-bind:key="item.key"
                >
                  <van-radio :name="item.key" checked-color="#ff6865">{{
                    item.value
                  }}</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>

          <van-field
            required
            name="radio"
            label="学校是否成立学校少工委"
            class="radioFlex"
            :rules="[{ required: true, message: '请选择学校是否成立学校少工委' }]"
            @change="radioChange($event, 'schoolsgw', clearSchoolsgw)"
          >
            <template #input>
              <van-radio-group
                v-model="schoolsgw"
                direction="horizontal"
                v-for="item in yORn"
                v-bind:key="item.key"
              >
                <van-radio :name="item.key" checked-color="#ff6865">{{
                  item.value
                }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <!-- sgwJobList -->
          <div v-if="schoolsgw == 1">
            <van-field
              required
              v-model="sgwName"
              clearable
              label="学校少工委主任姓名"
              placeholder="请输入学校少工委主任姓名"
              :rules="[{ required: true, message: '请输入学校少工委主任姓名' }]"
            />
            <van-field
              van-field
              required
              name="radio"
              label="学校少工委主任职务"
              :rules="[{ required: true, message: '请选择学校少工委主任职务' }]"
            >
              <template #input>
                <van-radio-group
                  v-model="sgwJob"
                  v-for="item in sgwJobList"
                  v-bind:key="item.key"
                  direction="vertical"
                >
                  <van-radio :name="item.key" checked-color="#ff6865">{{
                    item.value
                  }}</van-radio>
                </van-radio-group>
              </template>
            </van-field>
            <datetime-picker
              :value="sdhsj"
              title="本届少代会召开时间"
              type="year-month"
              :callback="(val) => handlerSelect('sdhsj', val)"
              :isRequired="sdhsjFlag"
            />
          </div>
        </template>
      </div>
      <!--登录按钮-->
      <div style="margin: 16px">
        <van-button round block type="primary" native-type="submit" class="btn btn_dl">
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import { reactive, toRefs, onMounted, watch, getCurrentInstance } from "vue";
import headers from "@/components/Header";
import {
  schoolTypes,
  eduList,
  zzmmList,
  titleList,
  concurrentCoursesList,
  batchTeamList,
  sgwJobList,
  jobList,
  sexs,
  yORn,
  buildingTeamList,
  viceCounselorList,
  eventScheduleList,
} from "@/common/js/field";
import diyPicker from "@/components/Select";
import datetimePicker from "@/components/DatePicker";
import { addForm, editForm, getsubmitData } from "@/service/form";
import {
  getKey,
  encrypt,
  rsaUtil,
  serverPublicKey,
  radioChange,
  validator,
  validatorMax,
  validatorNum,
} from "@/common/js";
import { useRoute, useRouter } from "vue-router";
// Toast,
import { Dialog } from "vant";

export default {
  name: "addForm1",
  setup() {
    const { proxy } = getCurrentInstance();
    const route = useRoute();
    const router = useRouter();
    let genKeyPair = rsaUtil.genKeyPair();
    window.jsPublicKey = genKeyPair.publicKey;
    window.jsPrivateKey = genKeyPair.privateKey;

    const state = reactive({
      schoolTypeTxt: "请选择学校类型",
      schoolType: null,
      schoolTypeFlag: false,
      schoolBuildingTeam: null,
      isBrigadeCounselor: null,
      name: null,
      sex: null,
      birthday: null,
      birthdayFlag: false,
      edu: null,
      zzmm: null,
      tel: null,
      job: null,
      title: null,
      counselorTime: null,
      counselorTimeFlag: false,
      squadronCounselorsNum: 0,
      squadronCounselorsPartyNum: 0,
      squadronCounselorsLeagueNum: 0,
      squadronCounselorsPeopleNum: 0,
      squadronCounselorsOtherNum: 0,
      concurrentCourses: null,
      squadronNum: 0,
      viceCounselorNum: 0,
      youngNum: 0,
      classHour: 0,
      squadronOutsideCounselorsNum: 0,
      brigadeOutsideCounselorsNum: 0,
      batchTeam: null,
      redScarf: null,
      badge: null,
      redScarfMedal: null,
      oneStar: null,
      schoolsgw: null,
      sgwJob: null,
      sdhsj: null,
      sdhsjFlag: false,
      sgwName: null,
      viceCounselor: null,
      eventSchedule: null,
      eventScheduleOther: 0,
      recommender: 0,
    });

    onMounted(() => {
      const { type } = route.query;
      if (type == 1) {
        getInfo();
      }
    });
    const getInfo = async () => {
      const { id } = route.query;
      const result = await getsubmitData({ dataId: id });
      const { code, data } = result;
      console.log("data ->", data);
      if (code == 10000 && data) {
        const newObj = {};
        for (const i of data.list) {
          let val = i.value;
          if (i.fieldCode == "schoolType") {
            const st = schoolTypes.filter((r) => r.key == i.value);
            if (st.length > 0) {
              state.schoolTypeTxt = st[0].value;
            }
          }
          if (
            i.fieldCode == "birthday" ||
            i.fieldCode == "counselorTime" ||
            i.fieldCode == "sdhsj"
          ) {
            val = val * 1000;
          }
          newObj[i.fieldCode] = val;
        }
        //   赋值
        Object.assign(state, newObj);
        formatSchoolType(state.schoolType);
      }
    };
    const formatSchoolType = (key) => {
      if ((key < 9 && key >= 5) || key <= 2) {
        console.log("小学");
      } else {
        console.log("小学以外");
        state.batchTeam = null;
        state.redScarf = null;
        state.badge = null;
      }
    };
    const selectSchoolTypes = (key, value) => {
      state.schoolType = key;
      state.schoolTypeTxt = value;
      state.schoolTypeFlag = false;
      // v-if="(schoolType < 9 && schoolType >= 5) || schoolType <= 2"
      formatSchoolType(key);
    };
    watch(
      () => [
        state.squadronCounselorsNum,
        state.squadronCounselorsPartyNum,
        state.squadronCounselorsLeagueNum,
        state.squadronCounselorsPeopleNum,
        state.squadronCounselorsOtherNum,
        
        state.classHour,
        state.squadronNum,
        state.youngNum,
        state.viceCounselorNum,
        state.brigadeOutsideCounselorsNum,
        state.squadronOutsideCounselorsNum,
        state.recommender,
      ],
      () => {
        formatNumber("squadronCounselorsNum");
        formatNumber("squadronCounselorsPartyNum");
        formatNumber("squadronCounselorsLeagueNum");
        formatNumber("squadronCounselorsPeopleNum");
        formatNumber("squadronCounselorsOtherNum");
        formatNumber("classHour");
        formatNumber("squadronNum");
        formatNumber("youngNum");
        formatNumber("viceCounselorNum");
        formatNumber("brigadeOutsideCounselorsNum");
        formatNumber("squadronOutsideCounselorsNum");
        formatNumber("recommender");
      }
    );

    const formatNumber = (item) => {
      if (state[item] == 0) {
        state[item] = 0;
        return false;
      }
      state[item] = Number(state[item]);
    };

    // 选择字段回调赋值
    const handlerSelect = (key, value) => {
      console.log(key, value);
      state[key] = value;
      if (key == "birthday") {
        state.birthdayFlag = false;
      }
      if (key == "counselorTime") {
        state.counselorTimeFlag = false;
      }
      if (key == "sdhsj") {
        state.sdhsjFlag = false;
      }
    };
    const handleFailed = (e) => {
      let msg = "请填写正确信息~"
      if(e && e.errors && e.errors.length>0) {
        msg = e.errors[0].message
      }
      Dialog.alert({
        message: msg,
      }).then(() => {
        console.log("-测试 then-");
      });
    };
    // 表单提交
    const onClickButtonSubmit = () => {
      const {
        schoolType,
        birthday,
        counselorTime,
        sdhsj,
        schoolsgw,
        isBrigadeCounselor,
      } = state;
      if (!schoolType) {
        state.schoolTypeFlag = true;
        return false;
      }
      if (isBrigadeCounselor == 1 && !birthday) {
        state.birthdayFlag = true;
        return false;
      }
      if (isBrigadeCounselor == 1 && !counselorTime) {
        state.counselorTimeFlag = true;
        return false;
      }
      if (schoolsgw == 1 && !sdhsj) {
        state.sdhsjFlag = true;
        return false;
      }

      Dialog.confirm({
        title: "提示",
        message: "你确定要提交吗？",
      })
        .then(() => {
          proxy.$showLoading();
          add(state);
        })
        .catch(() => {
          // on cancel
        });
    };
    const add = async (values) => {
      let arr = [];
      const { id, type } = route.query;
      let data = {
        formId: 2,
        list: [],
      };

      let fn = addForm;
      if (type == 1) {
        data.id = id;
        fn = editForm;
      }

      const whiteList = [
        "schoolTypeFlag",
        "schoolTypeTxt",
        "rules",
        "birthdayFlag",
        "counselorTimeFlag",
        "sdhsjFlag",
      ];

      for (let i in values) {
        let val = values[i];
        if (i == "birthday" && values[i] && values[i].toString().length > 10) {
          val = val / 1000;
          values[i] = val;
        }
        if (i == "counselorTime" && values[i] && values[i].toString().length > 10) {
          val = val / 1000;
          values[i] = val;
        }
        if (i == "sdhsj" && values[i] && values[i].toString().length > 10) {
          val = val / 1000;
          values[i] = val;
        }
      }

      for (const item in values) {
        let obj = {
          fieldCode: item,
          value: values[item],
        };
        if (whiteList.indexOf(item) !== -1) {
          continue;
        }
        if (values[item] || values[item] == 0) {
          arr.push(obj);
        }
      }
      data.list = arr;

      //随机获取AES的key
      let aesKey = getKey().toLowerCase();
      let param = {
        encryptData: encrypt(data, aesKey), //AES加密后的数据
        encrypted: rsaUtil.encrypt(aesKey, serverPublicKey), //后端RSA公钥加密后的AES的key
        // publicKey: window.jsPublicKey //前端公钥
      };

      try {
        const res = await fn(param);
        console.log("res -> ", res);
        if (res.code === 10000) {
          proxy.$closeLoading();
          Dialog.alert({
            message: "您提交的信息已提交审核，审核通过后将自动发布，请等待审核结果~",
          }).then(() => {
            goTo();
          });
        } else {
          proxy.$closeLoading();
        }
      } catch (error) {
        proxy.$closeLoading();
      }
    };
    const goTo = () => {
      // const { id, url } = route.query;
      // if (id) {
      router.push({ path: "/info/wtg" });
      // }
    };

    const goBack = () => {
      router.go(-1);
    };
    // 校验中队辅导员政治面貌数量不能超过中队辅导员人数
    const handleCheckSquadronPeople = () => {
      console.log('==handleCheckSquadronPeople==')
      const {squadronCounselorsNum, squadronCounselorsPartyNum, squadronCounselorsLeagueNum, squadronCounselorsPeopleNum, squadronCounselorsOtherNum} = state;
      if(squadronCounselorsNum == (squadronCounselorsPartyNum + squadronCounselorsLeagueNum + squadronCounselorsPeopleNum + squadronCounselorsOtherNum)) {
        return true
      } else {
        return false
      }
    }

    // 切换radio时清空内容
    const clearSchoolCounselor = (val) => {
      if (val == 2) {
        state.name = null;
        state.sex = null;
        state.birthday = null;
        state.edu = null;
        state.zzmm = null;
        state.tel = null;
        state.job = null;
        state.counselorTime = null;
        state.title = null;
        state.concurrentCourses = null;
        state.classHour = 0;
      }
    };
    const clearSchoolsgw = (val) => {
      if (val == 2) {
        state.sgwJob = null;
        state.sdhsj = null;
        state.sgwName = null;
      }
    };
    const clearRedScarfMedal = (val) => {
      if (val == 2) {
        state.oneStar = null;
      }
    };
    const clearSchoolBuild = (val) => {
      if (val == 2 || val == 3) {
        state.isBrigadeCounselor = null;
        state.name = null;
        state.sex = null;
        state.birthday = null;
        state.edu = null;
        state.zzmm = null;
        state.tel = null;
        state.job = null;
        state.title = null;
        state.counselorTime = null;
        state.squadronCounselorsNum = 0;

        state.squadronCounselorsPartyNum = 0;
        state.squadronCounselorsLeagueNum = 0;
        state.squadronCounselorsPeopleNum = 0;
        state.squadronCounselorsOtherNum = 0;

        state.concurrentCourses = null;
        state.squadronNum = 0;
        state.youngNum = 0;
        state.viceCounselorNum = 0;
        state.classHour = 0;
        state.squadronOutsideCounselorsNum = 0;
        state.brigadeOutsideCounselorsNum = 0;
        state.batchTeam = null;
        state.redScarf = null;
        state.badge = null;
        state.redScarfMedal = null;
        state.oneStar = null;
        state.schoolsgw = null;
        state.sgwJob = null;
        state.sdhsj = null;
        state.sgwName = null;
        state.viceCounselor = null;
        state.eventSchedule = null;
        state.eventScheduleOther = null;
        state.recommender = 0;
      }
    };
    const clearEventSchedule = val => {
      if(val != 5) {
        state.eventScheduleOther = 0
      }
    };
    const clearConcurrentCourses = (val) => {
      if (val == 1) {
        state.classHour = null;
      }
    };
    return {
      ...toRefs(state),
      onClickButtonSubmit,
      selectSchoolTypes,
      schoolTypes,
      eduList,
      zzmmList,
      titleList,
      sexs,
      yORn,
      buildingTeamList,
      concurrentCoursesList,
      eventScheduleList,
      batchTeamList,
      handlerSelect,
      sgwJobList,
      jobList,
      goBack,
      clearSchoolBuild,
      clearEventSchedule,
      clearSchoolCounselor,
      radioChange,
      clearConcurrentCourses,
      clearRedScarfMedal,
      clearSchoolsgw,
      validator,
      validatorMax,
      validatorNum,
      viceCounselorList,
      handleFailed,
      handleCheckSquadronPeople,
    };
  },
  components: {
    diyPicker,
    datetimePicker,
    headers,
  },
};
</script>

<style lang="less" scoped>
// @import "../../../common/style/mixin";
.radioStyle {
  background-color: #f90;
}

.back_left {
  width: 10%;
  height: 0.883rem;
  position: absolute;
  top: 0.233rem;
  left: 0.133rem;
  z-index: 99;
}
.go_back {
  height: 0.383rem;
  padding: 0.033rem 0 0 0.333rem;
  overflow: visible;
  color: rgb(255, 255, 255);
  font-size: 28px;
  z-index: 99;
}
:deep(.van-field__control--custom) {
  display: block;
}
.radioFlex :deep(.van-field__control--custom) {
  display: flex;
}

:deep(.van-cell__value),
:deep(.van-field__control),
:deep(.van-cell__right-icon) {
  color: #ff6865;
}
:deep(.van-radio__icon .van-icon) {
  border: 0.02667rem solid #ff6865 !important;
}
:deep(.van-cell__title) {
  color: #646566;
}
:deep(.van-radio-group) {
  padding: 0.168rem 0;
}
</style>
